module.exports = __webpack_public_path__ + "img/market-icon.25ab53b7.svg";